module.exports = __webpack_public_path__ + "img/google-play-store.e31ee2ee.svg";